<template>
  <div dir="rtl" class="flex flex_align_center file_margin">
    <checkbox
      ref="checkbox"
      v-if="isShowCheckbox()"
      @input="check"
      class="file_checkbox"
      :checked="is_checked"
    ></checkbox>
    <a
      @click="openFile"
      :class="{unauthorized_file: !is_authorized }"
      target="_blank"
      class="button file_link"
      >{{ file.name }}</a
    >
    <div
      v-if="!is_authorized"
      class="faded_border_bottom"
    >
      <p class="margin_0"><b>סיבות לשגיאה:</b></p>
      <p class="margin_0" v-for="file_error in errors" :key="file_error">
        תו לא מקובל - "<b>{{ file_error }}</b
        >"
      </p>
    </div>
    <div class="flex flex_align_center">
      <a @click="editFile" class="button is-outlined is-info">Edit</a>
      <div class="horizontal_space"></div>
      <a @click="deleteFile" class="button is-outlined is-danger">Delete</a>
      <div class="horizontal_space"></div>
      <p style="font-size: 12px;">{{ time_helper.makeTimeReadable(file.uploaded_at) }}</p>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import FileHelper from '@/classes/file_helper.js'
import TimeHelper from '@/classes/time_helper.js'
import Checkbox from '@/components/Checkbox'
export default {
  name: 'single-file',
  props: {
    file: {
      type: Object,
      default: () => {}
    },
    resource_id: {
      type: Number
    },
    resource_type: {
      type: String
    },
    is_checked: {
      type: Boolean,
      default: false
    },
    is_show_checkbox: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      file_helper: new FileHelper(),
      time_helper: new TimeHelper(),
      errors: [],
      is_authorized: false
    }
  },
  mounted () {
    this.errors = this.file_helper.getErrors(this.file.name)
    this.is_authorized = this.file_helper.isAuthorized(this.file.name)
    if (!this.isShowCheckbox()) {
      this.check(false)
    }
  },
  methods: {
    openFile () {
      this.$network_utils
        .getFile({
          file_name: this.file.name,
          resource_type: this.resource_type,
          resource_id: this.resource_id
        })
        .then(response => {
          let blob_file = new Blob([response], { type: 'application/pdf' })
          let blob_file_url = URL.createObjectURL(blob_file)
          let file_viewer_window = window.open(blob_file_url)
          setTimeout(() => {
            file_viewer_window.document.title = this.file.name
          }, 100)
        })
    },
    deleteFile () {
      this.createModal({
        designator: 'delete-prompt',
        component_name: 'DeletePrompt',
        modal_title: 'Delete ' + this.file.name,
        item_name: this.file.name,
        method: 'deleteFile',
        refresh: this.refresh,
        method_params: {
          file_name: this.file.name,
          resource_type: this.resource_type,
          resource_id: this.resource_id
        }
      })
    },
    editFile () {
      this.createModal({
        designator: 'file-editor',
        component_name: 'FileEditor',
        modal_title: 'Edit File - ' + this.file.name,
        file: this.file,
        resource_type: this.resource_type,
        resource_id: this.resource_id,
        refresh: this.refresh,
      })
    },
    refresh () {
      this.$emit('refresh')
    },
    check (value) {
      this.$emit('changed', value)
      this.$emit('input', value)
    },
    isShowCheckbox () {
      return this.is_show_checkbox && this.is_authorized
    },
    ...mapMutations('modals', ['createModal'])
  },
  components: {
    Checkbox
  }
}
</script>
